import { LinkButton, Tooltip } from '@pmi/dsm-react';
import {
  RemoveIcon,
  EditIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import { useEffect, useMemo, useState } from 'react';
import { TableCellProps } from '../models';
import styles from './actionsCell.module.scss';

function ActionsCell({ row, actions, personId = 0 }: TableCellProps) {
  const [disabledRemove, setDisabledRemove] = useState(
    !!actions.removableAdmin,
  );
  const canEdit = row.original.action?.editable;
  const canRemove = row.original.action?.deletable;
  const isOwnAccount = useMemo(() => {
    if (row.original.personId > 0) {
      return personId.toString() === row.original.personId.toString();
    }
    return !canEdit && !canRemove;
  }, [row.original, personId]);
  const removeTooltipMsg = useMemo(
    () =>
      isOwnAccount
        ? 'You do not have permission to remove yourself'
        : 'You do not have permission to remove this user. If you believe this is an error, please contact your account administrator',
    [row.original, personId],
  );

  const editTooltipMsg = useMemo(
    () =>
      isOwnAccount
        ? 'You do not have permission to edit yourself'
        : 'You do not have permission to edit this user. If you believe this is an error, please contact your account administrator',
    [row.original, personId],
  );

  useEffect(() => {
    setDisabledRemove(!!actions.removableAdmin);
  }, [actions.removableAdmin, row.original, personId]);

  return (
    <div className={`${styles.actionsContainer} d-flex`}>
      <Tooltip
        type="sm"
        content="Your account must have at least one Administrator"
        placement="top"
        blockTriggers={!disabledRemove}
        key={`adminActionTooltip-${row.original.personId}`}
        className="darkTooltip"
      >
        <div className={`${styles.tooltipContainer} d-flex`}>
          <Tooltip
            type="sm"
            content={editTooltipMsg}
            placement="top"
            blockTriggers={canEdit}
            className="darkTooltip"
          >
            <LinkButton
              className={`me-3 ${styles.actionButton}`}
              size="sm"
              disabled={!canEdit}
              onClick={() => {
                if (canEdit)
                  actions.onEdit({
                    ...row.original,
                    accountRole: row.original.role
                      ? row.original.accessType
                      : null,
                    isOwnAccount,
                  });
              }}
              titleText="Edit"
              icon={EditIcon}
            />
          </Tooltip>

          <Tooltip
            type="sm"
            content={removeTooltipMsg}
            placement="top"
            blockTriggers={canRemove}
            className="darkTooltip"
          >
            <LinkButton
              className={styles.actionButton}
              disabled={!canRemove}
              size="sm"
              onClick={
                !canRemove
                  ? () => {}
                  : () => {
                      actions.onRemove({
                        ...row.original,
                        accountRole: row.original.role
                          ? row.original.accessType
                          : null,
                      });
                    }
              }
              titleText="Remove"
              icon={RemoveIcon}
            />
          </Tooltip>
        </div>
      </Tooltip>
    </div>
  );
}

export default ActionsCell;
